import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { getMoment } from '../../../../core/utils/date.utils';

@Component({
  selector: 'app-datepicker-field',
  templateUrl: './datepicker-field.component.html',
  styleUrls: ['./datepicker-field.component.css']
})
export class DatepickerFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() class = 'field';
  @Input() type: 'both' | 'calendar' | 'timer' = 'both';
  @Input() minDate: number;
  @Input() maxDate: number;
  @Input() hideErrors = false;
  @Input() selectMode = 'single';
  @ViewChild('error') error;

  get min() {
    return (this.minDate) ? getMoment(this.minDate) : null;
  }

  get max() {
    return (this.maxDate) ? getMoment(this.maxDate) : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/datepicker-field/datepicker-field.component.ts